<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Usuários</h3>
        <d-link class="btn btn-success text-white float-right " href="/admin/usuarios/new">Novo usuário</d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Usuários Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <user-table :users="users.list" />
            </div>
            <pagination :total-items="users.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import UserTable from '../components/UserListTable.vue';

export default {
  name: 'user-list',
  components: {
    Pagination,
    UserTable,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    users() {
      const { userList } = this.$store.state.user;
      if (userList && userList.list.length) {
        return userList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getUserList',
    ]),
    getList() {
      this.getUserList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    this._onPagination = pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    };
    Events.$on('update:pagination', this._onPagination);
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination', this._onPagination);
  },

};
</script>

<style lang="scss" scoped>
</style>
